import React, { useState, useEffect, useCallback } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import { Link } from 'react-router-dom';
import ViewTip from '../../components/tips/ViewTip';
import DeleteModal from '../../components/DeleteModal';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import { useGlobalState } from '../../context/GlobalStateContext';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';
import MyDateRangePicker from '../../components/MyDateRangePicker';


function Tips() {
    const [tips, setTips] = useState([]);
    const { loading, setLoading, search, pagination, setPagination, handleSearch, handleLimitChange } = useGlobalState()
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    // const [startDate, setStartDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
    // const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [sortBy, setSortBy] = useState('');

    const handleDateRangeChange = (start, end) => {        
        setStartDate(start);
        setEndDate(end);
    };

    const fetchTips = useCallback(async (page = 1, limit = 10, searchQuery = '', from = '', to = '', sort = '') => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/tips/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                    startDate: from,
                    endDate: to,
                    sort: sort
                }
            });
            if (response.data.success) {
                setTips(response.data.data);
                setPagination(response.data.pagination);
            } else {
                setTips([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
            setTips([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        } finally {
            setLoading(false);
        }
    }, [setLoading, setPagination])

    const handleDelete = async (id) => {
        try {
            setLoading(true);

            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/tips/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchTips(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };

    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortBy(value);
        fetchTips(1, pagination.limit, search, startDate, endDate, value);
    };

    useEffect(() => {
        fetchTips(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
    }, [pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy, fetchTips]);


    return (
        <Layout title="Tips List">
            <main>
                <div className="card page-card" >
                    <div className="card-header d-xl-flex justify-content-between align-items-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <p>Show</p>
                                <Form.Select
                                    aria-label="Items per page"
                                    value={pagination.limit}
                                    onChange={handleLimitChange}
                                    style={{ minWidth: '80px' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </Form.Select>
                                <p>entries</p>
                            </div>
                            <div className='d-flex align-items-center gap-3 ms-3'>
                                <p>Sort by</p>
                                <Form.Select
                                    aria-label="Sort options"
                                    value={sortBy}
                                    onChange={handleSortChange}
                                    style={{ minWidth: '180px' }}
                                >
                                    <option value="title_asc">Title (A-Z)</option>
                                    <option value="title_desc">Title (Z-A)</option>
                                    <option value="newest">Newest First</option>
                                    <option value="oldest">Oldest First</option>
                                </Form.Select>
                            </div>
                        </div>
                        <div className='d-flex align-items-start align-items-md-center justify-content-end gap-2 flex-column flex-wrap flex-md-row mt-3 mt-xl-0'>
                            <MyDateRangePicker onDateChange={handleDateRangeChange} initialStartDate={startDate} initialEndDate={endDate} />
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchTips)}
                                    />
                                </InputGroup>
                            </div>
                            <Link to="/tips/add" className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3 add-hover'>
                                <img src="/images/png/plus.png" width={22} alt="" />
                                Add Tip
                            </Link>
                        </div>
                    </div>

                    <div className="card-body">

                        <div className="overflow-auto">
                            <Table responsive className='vertical-align'>
                                <thead>
                                    <tr>
                                        <th width="40">Id</th>
                                        <th>Title</th>
                                        <th>Favorites Count</th>
                                        <th>Published Date</th>
                                        <th>Created Date</th>

                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : tips.length > 0 ? (
                                        tips.map((item, index) => (
                                            <tr key={item._id}>
                                                <td width="40">
                                                    <p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p>
                                                </td>
                                                <td className='table-td-200'>
                                                    <p className='mb-0'>{item.title ? item.title : "-"}</p></td>
                                                <td className='table-td-200'>
                                                    <p className='mb-0'>{item.favoriteCount}</p>
                                                </td>
                                                <td className='table-td-150'>{item.date ? new Date(item.date).toISOString().split('T')[0] : "-"}</td>
                                                <td className='table-td-150'>{item.createdAt ? new Date(item.createdAt).toISOString().split('T')[0] : "-"}</td>
                                                <td>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <ViewTip tip={item} />
                                                        <OverlayTrigger
                                                            key="top"
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    Edit
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Link to={`/tips/edit/${item._id}`}>
                                                                <img src="/images/png/edit.png" className="pointer" width={35} alt="action" />
                                                            </Link>
                                                        </OverlayTrigger>

                                                        <DeleteModal
                                                            onConfirm={() => handleDelete(item._id)}
                                                            loading={loading}
                                                            flag={"tip"}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default Tips